import React from 'react';
import { Terminal } from 'lucide-react';

const LogViewer = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm">
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center">
          <Terminal className="w-6 h-6 text-blue-400 mr-3" />
          <div>
            <h2 className="text-xl font-semibold text-slate-200">Script Log Viewer</h2>
            <p className="text-slate-400 mt-1">View and analyze script execution logs</p>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="text-center py-12">
          <Terminal className="w-16 h-16 text-slate-600 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-300 mb-2">Script Log Viewer</h3>
          <p className="text-slate-400">This page will contain script log viewing functionality.</p>
        </div>
      </div>
    </div>
  );
};

export default LogViewer;